<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-swiper__swiper">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="请输入ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
         <el-select v-model="dataForm.status" placeholder="请选择状态" clearable>
           <el-option label="启用" :value="1"></el-option>
           <el-option label="禁用" :value="0"></el-option>  
         </el-select>   
         </el-form-item> 
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('swiper:swiper:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('swiper:swiper:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-popover placement="bottom" width="300" trigger="click" v-model="columnFilterVisible">
            <div class="column-filter-panel">
              <div class="filter-header">
                <span>列显示设置</span>
                <el-button type="text" size="small" @click="resetColumns">重置</el-button>
              </div>
              <el-checkbox-group v-model="selectedColumns" class="filter-checkboxes">
                <el-checkbox v-for="col in allColumns" :key="col.prop" :label="col.prop" :disabled="col.required">
                  {{ col.label }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <el-button slot="reference" icon="el-icon-setting">列筛选</el-button>
          </el-popover>
        </el-form-item>

      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" :fit="true" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column v-if="isColumnVisible('id')" prop="id" label="ID" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('type')" prop="type" label="跳转类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type == 0" type="success">跳转H5</el-tag>
            <el-tag v-if="scope.row.type == 1" type="success">跳转路径</el-tag>
        </template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('h5Url')" prop="h5Url" label="H5地址/跳转路径" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('createTime')" prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('updateDate')" prop="updateDate" label="更新时间" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('image')" prop="image" label="图片" header-align="center" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.image" width="100" height="40" alt=""/>
          </template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('hitCount')" prop="hitCount" label="点击数" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('orderNo')" prop="orderNo" label="排序" header-align="center" align="center"></el-table-column>

        <el-table-column v-if="isColumnVisible('status')" prop="status" label="状态" header-align="center" align="center">
          <template v-slot:="scope">
            <el-button plain size="mini" :type="scope.row.status==1?'success':'danger'" @click="switchStatus(scope.row.id,scope.row.status==0?1:0)">{{ formatStatus(scope.row.status) }}</el-button>

          </template>
        </el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('swiper:swiper:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-tooltip :content="scope.row.status === 1 ? '启用状态的广告不能删除，请先禁用' : '删除'" placement="top">
              <span>
                <el-button
                  v-if="$hasPermission('swiper:swiper:delete')"
                  type="text"
                  size="small"
                  :disabled="scope.row.status === 1"
                  @click="deleteHandle(scope.row.id)">
                  {{ $t('delete') }}
                </el-button>
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './swiper-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      columnFilterVisible: false,
      allColumns: [
        { prop: 'id', label: 'ID', required: false },
        { prop: 'type', label: '跳转类型', required: false },
        { prop: 'h5Url', label: 'H5地址/跳转路径', required: false },
        { prop: 'createTime', label: '创建时间', required: false },
        { prop: 'image', label: '图片', required: false },
        { prop: 'hitCount', label: '点击数', required: false },
        { prop: 'updateDate', label: '更新时间', required: false },
        { prop: 'orderNo', label: '排序', required: false },
        { prop: 'status', label: '状态', required: false }
      ],
      selectedColumns: [],
      operOptions:[{
        value: 'enable',
        label: '启用'
      },{
        value: 'disable',
        label: '禁用'
      }],
      mixinViewModuleOptions: {
        getDataListURL: '/swiper/swiper/page',
        getDataListIsPage: true,
        exportURL: '/swiper/swiper/export',
        deleteURL: '/swiper/swiper',
        switchStatusUrl:'/swiper/swiper/switch-status',
        deleteIsBatch: true
      },
      dataForm: {
        id: '',
        status: ''
      }
    }
  },
  components: {
    AddOrUpdate
  },
  created() {
    this.initSelectedColumns()
  },
  methods:{
    // 初始化选中的列
    initSelectedColumns() {
      const saved = localStorage.getItem('swiper_selected_columns')
      if (saved) {
        this.selectedColumns = JSON.parse(saved)
      } else {
        this.selectedColumns = this.allColumns.map(col => col.prop)
      }
    },
    // 判断列是否可见
    isColumnVisible(prop) {
      return this.selectedColumns.includes(prop)
    },
    // 重置列选择
    resetColumns() {
      this.selectedColumns = this.allColumns.map(col => col.prop)
      this.saveColumnSettings()
    },
    // 保存列设置
    saveColumnSettings() {
      localStorage.setItem('swiper_selected_columns', JSON.stringify(this.selectedColumns))
    },
    handleOperChange(val){
      console.log("handleOperChange",val)
      switch (val){
        case "enable":{
          this.switchStatus(null,1)
        }break;
        case "disable":{
          this.switchStatus(null,0)
        }break;
      }
    },
    formatStatus(status) {
       return status === 1 ? '启用' : '禁用'
    }
  },
  watch: {
    selectedColumns: {
      handler() {
        this.saveColumnSettings()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.column-filter-panel {
  .filter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #ebeef5;

    span {
      font-weight: 500;
      font-size: 14px;
    }
  }

  .filter-checkboxes {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 400px;
    overflow-y: auto;

    ::v-deep .el-checkbox {
      margin-right: 0;
      margin-left: 0;
    }
  }
}
</style>
